export default function sumElementsOnTabs() {
    const tabs = $('#tab-panes-parts').children();
    let tabsElementsSum = 0;

    //adds used elements
    for (let i = 0; i < tabs.length; i++) {
        const $tab = $(tabs[i]);
        let objectQ = $tab.find('.objects-quantity').val();

        //if part is type lotto then count other input value
            if ($tab.find('#category-stimuli-flex').is(':checked')) {
            objectQ = $tab.find('.lotto-objects-quantity').val();
        }

        let statementQ = $tab.find('.statements-quantity').val();
        tabsElementsSum += objectQ * statementQ;
    }

    return tabsElementsSum;
}
